const NavTopCTA = () => {
  return <></>
}

export default NavTopCTA
